<template>
  <div>
        
        <b-row class="m-b-20">
          <b-col cols="7">
             <h3 class="m-t-15">Stock Records</h3>
          </b-col>
          <b-col cols="5" class="stockDatePickerContainer">
            <b-form-datepicker  id="example-datepicker" v-model="date" class="mb-2" size="lg" locale="en" :min="min" :max="max" @input="populateStockRows"></b-form-datepicker>
          </b-col>
        </b-row>
        
       
       
        <div class="text-center" v-if="processing">
           <b-spinner variant="primary" v-show="processing" label="Spinning"></b-spinner>
        </div>

         <b-tabs  content-class="mt-3" >
            <b-tab title="Material Stocks" active>


              <b-row>
                <b-col cols="6">
                  <h4>(Total Material Items: {{ materialRecordsWithoutPrinter.length }})</h4>
                </b-col>
                <b-col cols="6">
                  <p class="text-right" v-if="materialRecordsWithoutPrinter.length > 0">This stocks records set creator : <strong>{{ materialRecordsWithoutPrinter.length > 0 ? materialRecordsWithoutPrinter[0].Doer.username : "Not Found" }}</strong></p>
                </b-col>
              </b-row>
        

                <section v-if="materialRecordsWithoutPrinter.length > 0 && !processing">
                    <single-material-editor v-for="stockRecord in materialRecordsWithoutPrinter" :key="stockRecord.id" :stock-record="stockRecord"/>
                </section>

            </b-tab>
            <b-tab title="Printers Ink Stock">

               <single-set-printer-inks v-for="(singleSet, index) in printerInkStockRecords" :key="index" :printer-ink-set="singleSet"/>


            </b-tab>

          </b-tabs>
        

  </div>
</template>

<script>

import moment from 'moment';

const SingleMaterialEditor = () => import(/* webpackChunkName: "stocks.single-material-editor" */ "./single-material-editor");

const SingleSetPrinterInks = () => import(/* webpackChunkName: "stocks.single-set-printer-inks" */ "./single-set-printer-inks");

import MaterialStockService from '../../../../../services/material-stock.service';


  export default {
    components: {SingleMaterialEditor, SingleSetPrinterInks},
    data() {

      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
   
      const minDate = new Date(today)
      minDate.setMonth(minDate.getMonth() - 2)
      minDate.setDate(15)
  
      const maxDate = new Date(today)

      return {
        date: moment().format('YYYY-MM-DD'),
        min: minDate,
        max: maxDate,
        materialStockRecords: [],
        processing: false
      }
    },
    mounted(){
       this.populateStockRows();
    },
    methods: {
      async populateStockRows(){
         try{
            this.processing = true;
            this.materialStockRecords = [];
            const apiResponse = await MaterialStockService.getPlusSetStockRecords({date: this.date});
            this.materialStockRecords = apiResponse.data.materialItemStockRecords;
         }catch(errors){
           console.log(errors);
         }finally{
           this.processing =  false;
         }
      },
      sortByCMYK(printerArr){
        let cmykOrder = {cyan: 0, magenta: 1, yellow: 2, black: 3};

        for(let i = 0; i < printerArr.length; i++){
           printerArr[i].inkData.sort(function(id1, id2){
              return cmykOrder[id1.inkName] - cmykOrder[id2.inkName];
           })
        }

        return printerArr;
      }
    },
    computed: {
      materialRecordsWithoutPrinter(){
         return this.materialStockRecords.filter(material => {
             if(material.ParentMaterial.TypeOfMaterial.materialType && material.ParentMaterial.TypeOfMaterial.materialType.toLowerCase() !== 'printer ink'){
                return true;
             }
         })
      },
      printerInkStockRecords(){

         let printerWiseData = [];
         let colorOrder = {cyan: 0, magenta: 1, yellow: 2, black: 3};

         

         for(let i=0; i < this.materialStockRecords.length; i++){
            if(this.materialStockRecords[i].ParentMaterial.TypeOfMaterial.materialType && this.materialStockRecords[i].ParentMaterial.TypeOfMaterial.materialType.toLowerCase() === 'printer ink'){
         
                let printerWithInkName = this.materialStockRecords[i].ParentMaterial.value.split('-').map(item => item.trim())

                // get printer name
                let printerName = printerWithInkName[1];
                let inkName = printerWithInkName[0].toLowerCase();

                // see if printer name exists
                let foundIndex = printerWiseData.findIndex(data => data.printerName == printerName)

                // define ink color
                this.materialStockRecords[i].inkName = inkName

                // if  printer record found, add to it
                if(foundIndex != -1){
                   
                   printerWiseData[foundIndex].inkData.push(this.materialStockRecords[i]);
                   
                }
                // else just create one.
                else{
                   let inkData = [];
                   inkData.push(this.materialStockRecords[i])
                   printerWiseData.push({
                     printerName,
                     inkData
                   })
                }
                
            }
         }

         
         printerWiseData = this.sortByCMYK(printerWiseData);
         
         return printerWiseData;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>